module.exports = __webpack_public_path__ + "img/banner05_info_S_3.65eb1d1c.png";